import React from 'react';

export default function StatusModifier({ orderHeader, highlightOpen }) {
    let status = orderHeader.orderStatus || orderHeader.status;
    return (
        <>
            {(() => {
                switch (status) {
                    case 'DELETED':
                        return (
                            <>
                                Deleted{orderHeader.deletedBy === 'SUPPLIER' ? ' by supplier' : ' on request'}
                            </>
                        );
                    case 'OPEN':
                        return highlightOpen ? <span className={'red'}>Open</span> : <>Open</>;
                    case 'SUBMITTED':
                        return <>Submitted</>;
                    case 'INVOICED':
                        return <>Invoiced</>;
                    case 'EXPIRED':
                        return <>Expired</>;
                    case 'DELIVERED':
                        return <>Delivered</>;
                    case 'PAID':
                        return <>Paid</>;
                    default:
                        return <>Unknown</>;
                }
            })()}
        </>
    );
}
